import { useEffect, useState } from 'react';

import { useStores } from '../stores';
import useConfig from './useConfig';
import useMenuFunctions from './useMenuFunctions';

export default function useEmailStopper() {
  const { emailStopper } = useConfig();
  const { app, bot, chat, chatWindow, ui } = useStores();
  const [isSent, setSent] = useState(false);
  const { executeFunction } = useMenuFunctions();

  function onClick() {
    chat.clearMessages();
    chat.isSpecialMessage = true;
    chatWindow.open();
    ui.setMessageInputDisabled(true);
    setSent(true);
  }

  function onClickLink(e) {
    e.preventDefault();
    ui.setMessageInputDisabled(false);
    executeFunction('getHotTopics');
    setTimeout(() => {
      executeFunction('getTopQuestions');
    }, 300);
  }

  useEffect(() => {
    if ((emailStopper && !emailStopper.enabled) || !emailStopper) {
      return () => {};
    }
    const { selector } = emailStopper;

    const node = document.querySelector(selector);
    let yesAnswer = null;

    if (node) {
      node.addEventListener('click', onClick);
    }

    if (isSent) {
      chat.isMessaging = true;
    }

    if (isSent && chat.messages.length === 0 && app.sessionId) {
      bot.runGetMqaLanguageWithSpecialIntent(emailStopper.intent);
      setSent(false);
    }

    if (chat.isSpecialMessage && chat.messages.length === 1) {
      yesAnswer = document.querySelector('.introyes');
      if (yesAnswer) {
        yesAnswer.addEventListener('click', onClickLink);
      }
    }

    if (chatWindow.isClosed) {
      chat.isSpecialMessage = false;
      if (yesAnswer) {
        yesAnswer.removeEventListener('click', onClick);
      }
    }

    return () => {
      if ((chatWindow.isOpened || !chat.messages.length) && node) {
        node.removeEventListener('click', onClick);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [app.sessionId, bot, chat, chat.messages.length, chatWindow, emailStopper, isSent]);
}
